import { PagedResults } from "../types/generics";
import { Programmazione } from "../types/Programmazione";
import { getEndpoint } from "../utils/stringUtil";
import client from "./axios";

const programmazioniUrl = `${getEndpoint()}api/programmazione`;

export const Programmazioni = {
  getProgrammazioni: (params?: URLSearchParams) =>
    client.get<PagedResults<Programmazione> | { list: Programmazione[] }>(`${programmazioniUrl}/get`, {
      params,
    }),
  getProgrammazione: (id: string) =>
    client.get<{ programmazione: Programmazione }>(`${programmazioniUrl}/single/${id}`),
  createProgrammazione: (formData: FormData) =>
    client.post<{ programmazione: Programmazione }>(`${programmazioniUrl}/create`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateProgrammazione: (id: string, formData: FormData) =>
    client.put<{ programmazione: Programmazione }>(`${programmazioniUrl}/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  deleteProgrammazione: (id: string) =>
    client.delete(`${programmazioniUrl}/${id}`),

  // Public templates ("Programmazioni Pubbliche") — browse catalog + self
  // assign/dissociate for athletes.
  getPublicCatalog: (params?: URLSearchParams) => {
    const merged = new URLSearchParams(params ?? undefined);
    merged.set("catalog", "true");
    return client.get<PagedResults<Programmazione> | { list: Programmazione[] }>(
      `${programmazioniUrl}/get`,
      { params: merged }
    );
  },
  getAssignedTemplateIds: () =>
    client.get<{ templateIds: string[] }>(`${programmazioniUrl}/assigned-templates`),
  assignTemplate: (id: string) =>
    client.post<{ programmazione: Programmazione }>(`${programmazioniUrl}/${id}/assign`),
  dissociateTemplate: (id: string) =>
    client.delete(`${programmazioniUrl}/${id}/assign`),
};
